import Ch from "../../assets/images/flags/ch.svg?react";

export default Ch;
